import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpService } from "./http.service";
import { Configuration } from '../configurations/shared.config';
import { Observable } from "rxjs";
import { SignalRCoreNotificationService } from './signalRCore-notification.service';

@Injectable()

export class OnlineUsersService {

    constructor(private http: Http, private httpService: HttpService, private signalRCoreService: SignalRCoreNotificationService) { }

    getOnlineUsers(loader: boolean = true): Observable<any> {
        return this.httpService.get(Configuration.urls.webApiEndpoint + Configuration.urls.GetOnlineStaffCount, null , loader).map(res => res.json());
    };

    receiveUserStatus(){
        return this.signalRCoreService.userStatusChanged;
    };

    getStaff(filtration): Observable < any > {
        return this.http.post(Configuration.urls.webApiEndpoint + Configuration.urls.filterStaffApi, filtration).map(res => res.json());
    };

    GetUserDetails(userId): Observable < any > {
        return this.http.get(Configuration.urls.webApiEndpoint + Configuration.urls.getUserDetailsUrl + userId).map(res => res.json());
    };

    GetBranchDetails(branchId): Observable < any > {
        return this.http.get(Configuration.urls.webApiEndpoint + Configuration.urls.branchUrl + branchId).map(res => res.json());
    };

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/onlineUsers.service.ts